import apiClient from './apiClient';

export interface N502Candidate {
  no: string;
  customer: string;
  amount: number;
  department: string;
  status: string;
  opinion: string;
  target_level: string;
}

export interface N502QueryRequest {
  start_no: string;
  end_no: string;
  broad: boolean;
}

export interface N502QueryResponse {
  items: N502Candidate[];
  total: number;
  level: string;
}

export interface N502ApproveItem {
  no: string;
  opinion: string;
  transfer: boolean;
  compensation: number;
}

export interface N502ApproveResult {
  no: string;
  success: boolean;
  new_status?: string;
  error?: string;
}

export interface N502ApproveResponse {
  results: N502ApproveResult[];
  success: number;
  failed: number;
}

export const n502Api = {
  async query(request: N502QueryRequest): Promise<N502QueryResponse> {
    const response = await apiClient.post('/api/n502/query', request);
    return response.data;
  },

  async approve(items: N502ApproveItem[]): Promise<N502ApproveResponse> {
    const response = await apiClient.post('/api/n502/approve', {
      confirmed: true,
      items,
    });
    return response.data;
  },
};
